import React, { useState, useCallback } from "react";
import { BlockEditProps } from "@wordpress/blocks";
import type { BlockAttributes } from "./block.json";
import { useBlockProps } from "@wordpress/block-editor";

export default function FormEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "" });

  return (
    <>
      <div {...blockProps}>
        <div className="d-flex justify-content-center py-5">
          <div className="form-container white">
            <h3 className="mb-5">KONTAKT</h3>
            <form className="d-flex flex-column">
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="kontaktperson"
                  placeholder="Kontaktperson"
                  required
                />
                <label htmlFor="kontaktperson">Kontaktperson</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="E-mail"
                  required
                />
                <label htmlFor="email">E-Mail</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="tel"
                  className="form-control"
                  id="telephone"
                  placeholder="Telephone"
                  required
                />
                <label htmlFor="telephone">Telefon</label>
              </div>

              <div className="form-floating mt-3 mb-5">
                <textarea
                  className="form-control"
                  id="nachricht"
                  placeholder="Nachricht"
                  style={{ height: "150px" }}
                  required
                ></textarea>
                <label htmlFor="nachricht">Nachricht</label>
              </div>

              <p className="copy-s">Datenschutz</p>
              <div className="mb-5 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="datenschutz"
                  required
                />
                <label className="form-check-label ps-3" htmlFor="datenschutz">
                  <p className="copy-s">
                    Ich erkläre mich damit einverstanden, dass der Gebetshaus
                    e.V.
                    <br />
                    meine Daten verarbeitet. Die Übermittlung dieser
                    Informationen
                    <br />
                    erfolgt freiwillig und ist jederzeit widerrufbar.
                  </p>
                </label>
              </div>

              <button type="submit" className="button align-self-end">
                Absenden
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
